import { useOpts } from '../context';
import { getLocalizedStringFn, } from '../consts/localized-strings';
/**
 * Hook that returns a getLocalizedString as a truthy value
 * rather than optional.
 */
export function useGetLocalizedString() {
    var opts = useOpts();
    if (opts.getLocalizedString) {
        return opts.getLocalizedString;
    }
    return getLocalizedStringFn('en');
}
